import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { InstituteApi } from "../services/api/institute";
import { Institute } from "../types/Institute";
import toast from "react-hot-toast";

export const useInstitute = (instituteId: number) => {
    const queryClient = useQueryClient();

    const queryKeys = {
        institute: (instituteId: number) => ['institute', instituteId], // List of classes
    };

    const getInstitute = () => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return useQuery({
            queryKey: queryKeys.institute(instituteId),
            queryFn: () => InstituteApi.GetInstituteById(instituteId),
            enabled: Boolean(instituteId),
            staleTime: 5 * 60 * 1000,
        });
    };

    const UpdateInstitute = useMutation({
        mutationFn: (data: Institute) => InstituteApi.UpdateInstitute(data),
        onSuccess: () => {
            toast.success("updated Successfully!!");
            queryClient.invalidateQueries({ queryKey: queryKeys.institute(instituteId) });
        },
        onError: (error) => {
            console.error("Error updating institute details:", error);
            toast.error((error as Error).message);
        }
    });

    return {
        getInstitute,
        UpdateInstitute
    }

}